import React, { useContext } from 'react';

import moment from 'moment';
import styled from 'styled-components';

import AttendanceMetric from './AttendanceMetric';
import AttendanceTable from './AttendanceTable';
import SummaryTable from './SummaryTable';
import { AttendanceContext, View } from '../../context/AttendanceContext';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const Summary = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    background: ${(props) => props.theme.colors.backgroundLight};
    padding: 2rem 0;
`;

const Title = styled.div`
    color: ${(props) => props.theme.colors.primary.main};
    font-size: 24px;
    margin-bottom: 2rem;
`;

const Padding = styled.div`
    padding: 1rem 2rem;
`;

const Metrics = styled.div`
    display: flex;
    align-items: center;
`;

const AttendanceOverview: React.FC = () => {
    const { t, totals, view, sessions, classSessionId } = useContext(AttendanceContext);

    const renderMetrics = () => {
        if (view !== View.Session) return;

        const session = sessions.find((i) => i.session_id === classSessionId);

        return (
            <Summary>
                <Title>
                    {moment(session?.start_time).format('h:mm A')} - {moment(session?.end_time).format('h:mm A')}
                </Title>

                <Metrics>
                    <AttendanceMetric
                        id="attendance-metric-students-present"
                        count={totals.present}
                        label={t('students-present')}
                    />
                    <AttendanceMetric
                        id="attendance-metric-students-absent"
                        count={totals.absent}
                        label={t('students-absent')}
                    />
                    <AttendanceMetric
                        id="attendance-metric-students-late"
                        count={totals.tardy}
                        label={t('students-tardy')}
                    />
                </Metrics>
            </Summary>
        );
    };

    const renderTable = () => {
        switch (view) {
            case View.Student:
            case View.Session:
                return <AttendanceTable />;
            case View.SessionSummary:
            case View.StudentSummary:
                return <SummaryTable />;
            default:
                return null;
        }
    };

    return (
        <Container>
            {renderMetrics()}
            <Padding>{renderTable()}</Padding>
        </Container>
    );
};

export default AttendanceOverview;
